import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
import {
  DepositGuiderContainer,
  StyledRightItem,
  StyledGuildLeft,
  StyledGuildRight,
  StyledStage,
  ArrowStep,
  StyledStepBonus,
  StyledStageMobile,
} from './styles';
import { useTranslation } from 'next-i18next';
import useTheme from '@/theme/useTheme';
import useUpdateUserInfoAsync, {
  UPDATE_USER_INFO_MODE,
} from '@/hooks/biz/useUpdateUserInfoAsync';
import {
  DepositBtn,
  DetailsComp,
  Stage1Text,
  Stage2Text,
  Stage3Text,
  Stage4Text,
} from './helpers';

export const GrantForEveryDeposit: React.FC<any> = () => {
  const [t] = useTranslation('promotion');
  const { theme } = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [{ isUserLoading, userMetaData }, updateUserInfo] =
    useUpdateUserInfoAsync();

  function getActiveClass(step: number) {
    return '';
    // if (isUserLoading) {
    //   return '';
    // }
    // if (!userBonusInfo.finishTask && step === 1) {
    //   return 'active';
    // }
    // return 1 === step ? 'active' : '';
  }

  useEffect(() => {
    updateUserInfo(UPDATE_USER_INFO_MODE.BONUS);
  }, [updateUserInfo]);
  return (
    <DepositGuiderContainer
      sx={{
        flexDirection: isMobile ? 'column' : 'row',
      }}
    >
      <StyledGuildLeft>
        <Typography
          variant="body1"
          fontWeight={700}
          fontSize={'32px'}
          lineHeight={1.2}
        >
          {t('GREAT BONUS FOR')}
        </Typography>
        <Typography
          variant="body1"
          fontWeight={700}
          fontSize={'32px'}
          lineHeight={1.2}
          sx={{
            marginY: isMobile ? '10px' : 0,
          }}
          color={'#F0B90B'}
        >
          {t('EVERY DEPOSIT')}
        </Typography>
        <Stack direction={'row'}>
          <Typography
            variant="body2"
            fontWeight={500}
            fontSize={'24px'}
            sx={{ mr: 1 }}
          >
            {t('Up to')}
          </Typography>
          <Typography
            variant="body2"
            fontWeight={500}
            fontSize={'24px'}
            color={'#F0B90B'}
          >
            {' 200%'}
          </Typography>
        </Stack>
        {/* <Typography
          variant="body2"
          fontWeight={500}
          fontSize={'16px'}
          sx={{ mt: 2 }}
          color={theme.palette.text.secondary}
        >
          {t('Available for all players')}
        </Typography>
        <Typography
          variant="body2"
          fontWeight={500}
          fontSize={'16px'}
          color={theme.palette.text.secondary}
        >
          Before 2024/4/1
        </Typography> */}
        {!isMobile ? <DetailsComp label={t('Details')} /> : <></>}
        <Box
          sx={{
            mt: 1,
            display: isMobile ? 'none' : 'flex',
          }}
        >
          <DepositBtn />
        </Box>
      </StyledGuildLeft>
      {isMobile ? (
        <StyledGuildRight
          sx={{
            width: '100%',
            marginY: isMobile ? '20px' : 0,
          }}
        >
          <StyledStageMobile step={1}>
            <Stage1Text />
          </StyledStageMobile>
          <StyledStageMobile step={2}>
            <Stage2Text />
          </StyledStageMobile>
          <StyledStageMobile step={3}>
            <Stage3Text />
          </StyledStageMobile>
          <StyledStageMobile step={4}>
            <Stage4Text />
          </StyledStageMobile>
          <Stack direction={'row'} width={'100%'} mt={2.5}>
            <Box sx={{ flex: 1 }}>
              <DepositBtn />
            </Box>
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
              <DetailsComp label={t('Details')} />
            </Box>
          </Stack>
        </StyledGuildRight>
      ) : (
        <StyledGuildRight>
          <StyledRightItem
            className={getActiveClass(1)}
            sx={{
              zIndex: 4,
            }}
          >
            <Box
              sx={{
                paddingTop: '121%',
                width: '100%',
              }}
            ></Box>
            <StyledStage className="stage">
              <StyledStepBonus className={`bg bg1`}>
                <Stage1Text />
              </StyledStepBonus>
              <ArrowStep className="arrow arrow1" />
            </StyledStage>
            {getActiveClass(1) ? <DepositBtn /> : <></>}
          </StyledRightItem>
          <StyledRightItem
            className={getActiveClass(2)}
            sx={{
              zIndex: 3,
            }}
          >
            <Box
              sx={{
                paddingTop: '121%',
                width: '100%',
              }}
            ></Box>
            <StyledStage className="stage">
              <StyledStepBonus className={`bg bg2`}>
                <Stage2Text />
              </StyledStepBonus>
              <ArrowStep className="arrow2" />
            </StyledStage>
            {getActiveClass(2) ? <DepositBtn /> : <></>}
          </StyledRightItem>
          <StyledRightItem
            className={getActiveClass(3)}
            sx={{
              zIndex: 2,
            }}
          >
            <Box
              sx={{
                paddingTop: '121%',
                width: '100%',
              }}
            ></Box>
            <StyledStage className="stage">
              <StyledStepBonus className={`bg bg3`}>
                <Stage3Text />
              </StyledStepBonus>
              <ArrowStep className="arrow3" />
            </StyledStage>
            {getActiveClass(3) ? <DepositBtn /> : <></>}
          </StyledRightItem>
          <StyledRightItem
            className={getActiveClass(4)}
            sx={{
              zIndex: 1,
            }}
          >
            <Box
              sx={{
                paddingTop: '121%',
                width: '100%',
              }}
            ></Box>
            <StyledStage className="stage">
              <StyledStepBonus className={`bg bg4 ${getActiveClass(4)}`}>
                <Stage4Text />
              </StyledStepBonus>
            </StyledStage>
            {getActiveClass(4) ? <DepositBtn /> : <></>}
          </StyledRightItem>
        </StyledGuildRight>
      )}
    </DepositGuiderContainer>
  );
};
